import { defineComponent, useCssModule, createElementBlock, openBlock, unref, normalizeClass, createElementVNode, createVNode, createCommentVNode, toDisplayString, Fragment } from "vue";
import { WLottie } from "../../../../WLottie/index.js";
import { animationData } from "../../../../../assets/lottie/counter.js";
import { _export_sfc } from "../../../../WAccordion/index.js";
import './index.css';const DATA_T = {
  WRAP: "w-casino-card-counter-wrap",
  TITLE: "w-casino-card-counter-title",
  DOT: "w-casino-card-counter-dot",
  MAX_VALUE: "w-casino-card-counter-max-value",
  MAX_SEPARATOR: "w-casino-card-counter-max-separator",
  SUBTITLE: "w-casino-card-counter-subtitle"
};
const _hoisted_1 = ["data-t"];
const _hoisted_2 = ["data-t"];
const _hoisted_3 = ["data-t"];
const _hoisted_4 = ["data-t"];
const _hoisted_5 = ["data-t"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WCasinoCardCounter",
  props: {
    counter: {},
    max: {},
    subtitle: {}
  },
  setup(__props) {
    const style = useCssModule();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(style).wrap),
        "data-t": unref(DATA_T).WRAP
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(style).title)
        }, [
          createVNode(unref(WLottie), {
            class: normalizeClass(unref(style).dot),
            "animation-data": unref(animationData),
            autoplay: "",
            loop: "",
            "is-current-color": "",
            "data-t": unref(DATA_T).DOT
          }, null, 8, ["class", "animation-data", "data-t"]),
          createElementVNode("div", {
            class: normalizeClass(unref(style).textWrap)
          }, [
            createElementVNode("span", {
              "data-t": unref(DATA_T).TITLE
            }, toDisplayString(_ctx.counter), 9, _hoisted_2),
            _ctx.max !== void 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createElementVNode("span", {
                "data-t": unref(DATA_T).MAX_SEPARATOR
              }, "/", 8, _hoisted_3),
              createElementVNode("span", {
                "data-t": unref(DATA_T).MAX_VALUE
              }, toDisplayString(_ctx.max), 9, _hoisted_4)
            ], 64)) : createCommentVNode("", true)
          ], 2)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(style).subtitle),
          "data-t": unref(DATA_T).SUBTITLE
        }, toDisplayString(_ctx.subtitle), 11, _hoisted_5)
      ], 10, _hoisted_1);
    };
  }
});
const wrap = "IY6ui";
const title = "eXs-e";
const textWrap = "ogbHy";
const dot = "_3fAR7";
const subtitle = "d32pE";
const style0 = {
  wrap,
  title,
  textWrap,
  dot,
  subtitle
};
const cssModules = {
  "$style": style0
};
const WCasinoCardCounter = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  WCasinoCardCounter
};
